import { Link } from '@tanstack/react-router';
import { HouseholdSwitcher } from '../household-switcher.js';
import { AccountNav, CollectionsNav, PrimaryNavLinks, TagsNav } from './nav-sections.js';

/**
 * The column of navigation beside the page on wide screens.
 *
 * Below 900px the shell renders {@link MobileTabbar} and the More sheet instead of this —
 * stacking a sidebar this tall above the content pushed the recipes off the first screen.
 */
export function AppSidebar({ onAddCollection }: { onAddCollection: () => void }) {
  return (
    <aside className="sidebar">
      <Link className="brand" to="/">
        <img className="brand-mark" src="/logo.png" alt="" width={32} height={32} /> Platewell
      </Link>

      <HouseholdSwitcher />

      <nav className="nav" aria-label="Main">
        <PrimaryNavLinks />
        <CollectionsNav onAdd={onAddCollection} />
        <TagsNav />
      </nav>

      <span className="spacer" />
      <AccountNav />
    </aside>
  );
}
